<template>
  <TagInput
    v-bind="$props"
    :min="validatorOptions.tags.min"
    :max="validatorOptions.tags.max"
    :max-length="validatorOptions.tags.maxlength"
    :is-valid="valid"
    :name="name"
    :source-entity-id="idea?.id"
  />
</template>

<script>
import ideaValidator from 'commons/api/validators/idea/ideaValidator';
import ideaHelper from 'commons/ideaHelper/ideaHelper';
import TagInput from './TagInput.vue';

export default {
  name: 'IdeaTagInput',
  components: {
    TagInput,
  },
  props: {
    validate: {
      type: Boolean,
    },
    idea: {
      type: Object,
    },
    locale: {
      type: String,
    },
  },
  data() {
    return {
      validatorOptions: ideaValidator.getDefaultOptions(),
    };
  },
  computed: {
    name() {
      return this.idea
        ? ideaHelper.getTranslation(this.idea, this.locale)?.name
        : null;
    },
    valid() {
      if (!this.idea || !this.validate) {
        return true;
      }
      return ideaValidator.validateTags(this.idea, { locale: this.locale });
    },
  },
};
</script>
